package com.eladfinish.bible.contest.screens.browse.usecases

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.common.ChaptersRepository
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.data.common.stringResolver.StringResolver
import com.eladfinish.bible.contest.perek_str
import com.eladfinish.bible.contest.tiqun_haklali_ending
import com.eladfinish.bible.contest.tiqun_haklali_intro
import com.eladfinish.bible.contest.utils.MyStringUtils.replaceSpaceWithNoBreakSpace
import com.eladfinish.bible.contest.utils.addGershaim
import com.eladfinish.bible.contest.utils.getOtiot
import com.eladfinish.bible.contest.utils.removeWhitespacesAndParshiot
import com.eladfinish.bible.contest.utils.replaceKtivWithQriNew
import dev.icerock.moko.resources.desc.desc

class GetTiqunHaklaliUseCase(
    private val assetReader: AssetReader,
    private val stringResolver: StringResolver,
) {

    private val chapterNums = listOf(16, 32, 41, 42, 59, 77, 90, 105, 137, 150)
    private val book = "tehilim"
    private val bookIndex = 27

    operator fun invoke(): String {
        val stringBuilder = StringBuilder()
        stringBuilder.append(stringResolver.resolveString(SharedRes.strings.tiqun_haklali_intro.desc())).append("\n")
        for (chapterNum in chapterNums) {
            val paddedChapter = ChaptersRepository.padNumber(bookNameEnglish = book, chapterNum = chapterNum)
            val filename = ChaptersRepository.getFileFormat(number = bookIndex, bookName = book, chapter = paddedChapter)
            var content = assetReader.readFile(fileName = StringConstants.ALL_CHAPTERS + assetReader.fileSeparator + filename)
            content = content
                .substringAfter(StringConstants.NEW_LINE).trim()
                .replaceKtivWithQriNew()
                .removeWhitespacesAndParshiot()
                .replaceSpaceWithNoBreakSpace()
            val perek = "[" + stringResolver.resolveString(SharedRes.strings.perek_str.desc()) +
                    " " + getOtiot(chapterNum).addGershaim() + "]"
            stringBuilder.append(perek).append("\n")
                .append(content).append("\n\n")
        }
        stringBuilder.append(stringResolver.resolveString(SharedRes.strings.tiqun_haklali_ending.desc()))

        return stringBuilder.toString()
    }
}
